import { useAuth } from "../../../../../context";
import { useMutation, useQuery } from "react-query";
import {
  SupplierQuestionnaireDownstreamTransportationAndDistribution
} from "../../../../../api/supplier-questionnaire/tabs/categories";

export const supplierQuestionnaireDownstreamTransportationAndDistributionKeys = {
  items: () => ["supplierQuestionnaireDownstreamTransportationAndDistributionItems"],
  preview: () => ["supplierQuestionnaireDownstreamTransportationAndDistributionPreviewData"]
};

export function useGetSupplierQuestionnaireDownstreamTransportationAndDistributionItems(params, config) {
  const { callApi } = useAuth();
  return useQuery(
    [...supplierQuestionnaireDownstreamTransportationAndDistributionKeys.items(),
      params.queryParams.page, params.queryParams.size, params.queryParams.sort],
    () => callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.getDownstreamTransportationAndDistributionItems, params), config);
}

export function useAddSupplierQuestionnaireDownstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.addDownstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useUpdateSupplierQuestionnaireDownstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.updateDownstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId,
      data
    }), config);
}

export function useDeleteSupplierQuestionnaireDownstreamTransportationAndDistributionItem(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.deleteDownstreamTransportationAndDistributionItem, {
      questionnaireId,
      recordId
    }), config);
}

export function useImportSupplierQuestionnaireDownstreamTransportationAndDistributionItems(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.importDownstreamTransportationAndDistributionItems, {
      questionnaireId,
      data
    }), config);
}

export function useGetDownstreamTransportationAndDistributionPreviewData(previewId, params, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierQuestionnaireDownstreamTransportationAndDistributionKeys.preview(),
      previewId, params.page, params.size],
    () => callApi(SupplierQuestionnaireDownstreamTransportationAndDistribution.getDownstreamTransportationAndDistributionPreviewData,
      { previewId, params }), config);
}